import { render, staticRenderFns } from "./viewTaskDetail.vue?vue&type=template&id=281faca9"
import script from "./viewTaskDetail.vue?vue&type=script&lang=js"
export * from "./viewTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports